<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
	data(){
		return {
			
		}
	},
	created:function(){
		
	},
	methods:{
		
	},
};
</script>

<style scoped>
div {
	background: #F5F6F7;
	padding: 5px 5px;
}
</style>
